var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBorrowWen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.16 11.562C19.3589 11.562 19.5497 11.483 19.6903 11.3423C19.831 11.2017 19.91 11.0109 19.91 10.812C19.91 10.6131 19.831 10.4223 19.6903 10.2817C19.5497 10.141 19.3589 10.062 19.16 10.062H16.47L21.19 5.34201C21.2637 5.27335 21.3228 5.19055 21.3638 5.09855C21.4048 5.00655 21.4268 4.90724 21.4286 4.80653C21.4304 4.70583 21.4118 4.6058 21.3741 4.51241C21.3364 4.41902 21.2803 4.33419 21.209 4.26297C21.1378 4.19175 21.053 4.13561 20.9596 4.09789C20.8662 4.06017 20.7662 4.04164 20.6655 4.04342C20.5648 4.0452 20.4655 4.06724 20.3735 4.10823C20.2815 4.14922 20.1987 4.20832 20.13 4.28201L15.41 9.00201V6.31201C15.41 6.1131 15.331 5.92233 15.1903 5.78168C15.0497 5.64103 14.8589 5.56201 14.66 5.56201C14.4611 5.56201 14.2703 5.64103 14.1297 5.78168C13.989 5.92233 13.91 6.1131 13.91 6.31201V10.812C13.91 11.0109 13.989 11.2017 14.1297 11.3423C14.2703 11.483 14.4611 11.562 14.66 11.562H19.16Z",
    fill: "url(#paint0_linear_3443_14044)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.68871 19.5276H6.42871C5.48571 19.5276 5.01471 19.5276 4.72171 19.2346C4.42871 18.9426 4.42871 18.4716 4.42871 17.5286V16.4166C4.42871 15.8986 4.42871 15.6396 4.56171 15.4076C4.69471 15.1766 4.89571 15.0596 5.29771 14.8256C7.94371 13.2866 11.6997 12.4206 14.2077 13.9156C14.3757 14.0166 14.5277 14.1386 14.6577 14.2836C14.792 14.4308 14.8955 14.6034 14.962 14.7912C15.0285 14.9791 15.0567 15.1783 15.045 15.3772C15.0332 15.5761 14.9818 15.7706 14.8936 15.9493C14.8055 16.128 14.6824 16.2873 14.5317 16.4176C14.4115 16.5318 14.2648 16.6143 14.1047 16.6576C14.2247 16.6436 14.3397 16.6276 14.4497 16.6106C15.3607 16.4656 16.1257 15.9776 16.8257 15.4486L18.6337 14.0836C18.9563 13.849 19.3449 13.7226 19.7437 13.7226C20.1426 13.7226 20.5312 13.849 20.8537 14.0836C21.4267 14.5166 21.6027 15.2296 21.2397 15.8116C20.8167 16.4896 20.2207 17.3566 19.6487 17.8866C19.0757 18.4166 18.2227 18.8906 17.5267 19.2266C16.7547 19.5996 15.9027 19.8136 15.0357 19.9546C13.2777 20.2386 11.4457 20.1946 9.70571 19.8366C8.713 19.6325 7.70219 19.5283 6.68871 19.5276Z",
    fill: "url(#paint1_linear_3443_14044)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3443_14044",
    x1: 13.91,
    y1: 11.562,
    x2: 21.8015,
    y2: 11.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3443_14044",
    x1: 21.4289,
    y1: 13.1401,
    x2: 3.84767,
    y2: 15.4982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBorrowWen);
export default __webpack_public_path__ + "static/media/icon-borrowWen.03053b3df2a97612ab723eb79d23bea6.svg";
export { ForwardRef as ReactComponent };